import { dropEndpointIds, TargetedOutreachGroup } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const sendTargetedDropOutreachEndpoint = {
    [dropEndpointIds.SEND_TARGETED_DROP_OUTREACH]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropIds: { type: 'array', items: { type: 'string' }, minItems: 1 },
                ratio: { type: 'number', minimum: 0, maximum: 1 },
                singleSendId: { type: 'string' },
                activityRange: { type: 'number', minimum: 0 },
                group: { type: 'string', enum: Object.values(TargetedOutreachGroup) },
            },
            required: ['dropIds', 'ratio', 'singleSendId', 'activityRange', 'group'],
        },
    },
};
